import { HttpClient, HttpParams } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import {
    BABOOR_ENVIRONMENT,
    BaboorEnvironmentConfig,
} from '@baboor/baboor-core'
import { Service, ServiceDto } from '@baboor/baboor-models'
import { ApiResponse } from '@baboor/common-models'
import { toHttpParams } from '@baboor/common-util'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ShopServicesApiService {
    private apiUrl: string

    constructor(
        private http: HttpClient,
        @Inject(BABOOR_ENVIRONMENT) private env: BaboorEnvironmentConfig,
    ) {
        this.apiUrl = `${env.apiUrl}/v1/services`
    }

    getAll(params?: {
        page?: number
        size?: number
        search?: string
        category?: string
        isActive?: boolean
        organizationId?: string
    }): Observable<ApiResponse<Service[]>> {
        const httpParams = toHttpParams(params ?? {})
        return this.http.get<ApiResponse<Service[]>>(this.apiUrl, {
            params: httpParams,
        })
    }

    getById(id: string): Observable<ApiResponse<Service>> {
        return this.http.get<ApiResponse<Service>>(`${this.apiUrl}/${id}`)
    }

    create(data: ServiceDto): Observable<ApiResponse<Service>> {
        return this.http.post<ApiResponse<Service>>(this.apiUrl, data)
    }

    update(
        id: string,
        data: Partial<ServiceDto>,
    ): Observable<ApiResponse<Service>> {
        return this.http.patch<ApiResponse<Service>>(
            `${this.apiUrl}/${id}`,
            data,
        )
    }

    delete(id: string): Observable<ApiResponse<unknown>> {
        return this.http.delete<ApiResponse<unknown>>(`${this.apiUrl}/${id}`)
    }
}
